import React, { useEffect, useState } from 'react';
import FeedbackRow from './FeedbackRow';
import { Col, Row, Table, Form } from 'react-bootstrap';
import { getAllFeedbacks } from '../../api/feedbackAPI';
import moment from 'moment';

const FeedbackTable = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [filterDate, setFilterDate] = useState('');

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const response = await getAllFeedbacks();
        setFeedbacks(response);
        setFilteredFeedbacks(response);
      } catch (error) {
        setFeedbacks([]);
        setFilteredFeedbacks([]);
      }
    };

    fetchFeedbacks();
  }, []);

  useEffect(() => {
    if (filterDate) {
      const modifiedDate = moment(filterDate).format('M/D/YYYY');
      // console.log(`Filter Date: ${filterDate}`);
      // console.log(`Modified Date for Comparison: ${modifiedDate}`);

      const filtered = feedbacks.filter((feedback) => {
        return feedback.feedbackEntries.some((entry) => {
          // Accessing the correct date property within appointmentID
          const appointmentDate = moment(entry.appointmentID?.date).format('M/D/YYYY');
          const isMatch = appointmentDate === modifiedDate;
          // console.log(`Checking entry appointmentDate: ${appointmentDate} against ${modifiedDate}, Match: ${isMatch}`);
          return isMatch;
        });
      });

      // console.log('Filtered Feedbacks:', filtered);
      setFilteredFeedbacks(filtered);
    } else {
      // console.log('No filter date provided, showing all feedbacks.');
      setFilteredFeedbacks(feedbacks);
    }
  }, [filterDate, feedbacks]);



  const handleDateChange = (e) => {
    setFilterDate(e.target.value);
  };

  const rows = [];
  const data = filteredFeedbacks.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  data.forEach((feedback) => {
    const { employeeID, feedbackEntries } = feedback;
    feedbackEntries.forEach((entry) => {
      rows.push(
        <FeedbackRow
          key={entry._id}
          employeeName={employeeID.name}
          entry={entry}
        />
      );
    });
  });

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>Feedbacks</h1>
        </Col>
        <Col md={4}>
          <Form.Group controlId="appointmentDateFilter">
            {/* <Form.Label>Filter by Appointment Date</Form.Label> */}
            <Form.Control
              type="date"
              value={filterDate}
              onChange={handleDateChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Table striped bordered hover responsive className='table-sm'>
        <thead>
          <tr>
            <th>Employee Name</th>
            <th>Rating</th>
            <th>Comment</th>
            <th>Feedback Created By</th>
            <th>Appointment Date</th>
            <th>Appointment Time</th>
            <th>Date Created</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </>
  );
};

export default FeedbackTable;
